import {useState} from 'react'
import exportFromJSON from 'export-from-json'
import {KTSVG} from '../../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {CoordinatorsListFilter} from './CoordinatorsListFilter'
import {Menus, isAccessGranted} from '../../../../../../../app/helpers/MenuAccessControl'
import {Coordinator} from '../../core/_models'
import {getAllExportXls} from '../../core/_requests'
import {useAuth} from '../../../../../auth'

type PropTypes = {
  showAddCoordinator?: boolean
}

const CoordinatorsListToolbar = ({showAddCoordinator = true}: PropTypes) => {
  const {setItemIdForUpdate} = useListView()
  const openAddCoordinatorModal = () => {
    setItemIdForUpdate(null)
  }
  const [isExporting, setIsExporting] = useState(false);
  const auth = useAuth()

  const exportXLS = async () => {
    setIsExporting(true);
    const res = await getAllExportXls(auth.currentUser?.last_company_id);
    const data: Coordinator[] = (res) ? res : []
    const fileName = 'cmb-xls-coordenadores';
    const exportType = 'xls';
    setIsExporting(false);

    exportFromJSON({ data, fileName, exportType });
  }

  return (
    <div className='d-flex justify-content-end' data-kt-user-table-toolbar='base'>
      <CoordinatorsListFilter />
      <button type='button' className='btn btn-light-primary me-3' onClick={exportXLS}>
        {isExporting ? (
          <span>
            Exportando...{' '}
            <span className='spinner-border spinner-border-sm align-middle ms-2'></span>
          </span>
        ) : (
          <>
            <KTSVG path='/media/icons/duotune/general/export.svg' className='svg-icon-2' />
            Exportar Coordenadores
          </>
        )}
      </button>
      {/* begin::Add coordinator */}
      {showAddCoordinator && (
        <button type='button' className='btn btn-primary' style={{display:(isAccessGranted(Menus.coordinators.id).write) ? '': 'none'}} onClick={openAddCoordinatorModal}>
          <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
          Adicionar Coordenador
        </button>
      )}
      {/* end::Add coordinator */}
    </div>
  )
}

export {CoordinatorsListToolbar}
